import React from "react";
import { appendScript } from "../../helpers";

class FormikCkEditor extends React.Component {
  constructor(props) {
    super(props);
    appendScript ("//cdn.ckeditor.com/4.6.1/basic/ckeditor.js"); //Load the script
    window.addEventListener('load', this.componentDidMount.bind(this));
  }

  componentDidMount() {
    const { name } = this.props;      
    let configuration = {
      toolbar: "Basic"
    };
    const CKEDITOR = window.CKEDITOR;
    if(!!CKEDITOR) {
      CKEDITOR.replace("editor", configuration);
      CKEDITOR.instances.editor.on('change', function () {
        let data = CKEDITOR.instances.editor.getData();
        this.props.setFieldValue(name, data);
      }.bind(this));
    }
  }

  render() {
    const { title, value, className, placeholder } = this.props;

    return (
      <React.Fragment>
        {title &&  <label>{title}</label>}
        <div className="input-group mb-3">
          <textarea 
            //id={this.props.id}
            name="editor" 
            style={{"visibility":"hidden"}}
            placeholder={placeholder}
            className={className}
            rows="6" 
            defaultValue={value}
            ></textarea>
        </div>
      </React.Fragment>
    );
  }
}

export default FormikCkEditor;
